module.exports = __webpack_public_path__ + "static/assets/4a86c1c251c1155a5ee68c125ac8bd89.png";